import React from 'react'
import { Divider, MenuItem } from '@mui/material'
import { useNavigate } from 'react-router'
import { useUser } from '../generic/hooks/useUser'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

/**
 * Backoffice menu item for the gear/settings menu in TopBar.
 * Rendered only for users whose profile.code === 'SUPERADMIN' (D1/P5).
 *
 * @param {{ onClose: function }} props
 */
const BackofficeMenuItem = ({ onClose }) => {
  const { user } = useUser()
  const { t_ } = useSmartTranslation()
  const navigate = useNavigate()

  if (user?.profile?.code !== 'SUPERADMIN') {
    return null
  }

  const handleClick = () => {
    onClose()
    navigate('/backoffice/proxiedServices')
  }

  return (
    <>
      <Divider />
      <MenuItem onClick={handleClick} role='menuitem'>
        {t_('Backoffice')}
      </MenuItem>
    </>
  )
}

export default BackofficeMenuItem
